export default "__VITE_ASSET__ByDnDwnG__"